<template>
  <MoreOptionsMenuButton
    v-bind="attrs"
    v-if="
      currentUser?.hasPermission('customers.change_customer') ||
      currentUser?.hasPermission('customers.delete_customer') ||
      currentUser?.hasPermission('users.change_user') ||
      currentUser?.hasPermission('users.change_password')
    "
  >
    <v-list-item
      v-if="currentUser.hasPermission('customers.change_customer')"
      @click="emit('customer-edit-pressed', customer)"
      title="Edit Customer"
    >
      <template #prepend>
        <v-icon size="18" icon="mdi-pencil" class="me-1" />
      </template>
    </v-list-item>

    <v-list-item
      v-if="currentUser.hasPermission('customers.change_customer')"
      @click="emit('customer-change-sites-pressed', customer)"
      title="Manage Sites"
    >
      <template #prepend>
        <v-icon size="18" icon="mdi-domain-switch" class="me-1" />
      </template>
    </v-list-item>

    <v-list-item
      v-if="currentUser.hasPermission('users.change_password')"
      @click="emit('customer-change-password-pressed', customer)"
      title="Change Password"
    >
      <template #prepend>
        <v-icon size="18" icon="mdi-account-lock" class="me-1" />
      </template>
    </v-list-item>

    <v-list-item
      v-if="currentUser.hasPermission('users.change_user')"
      @click="emit('customer-set-active-pressed', customer)"
      color="error"
      :title="`${customer.is_active ? 'Deactivate' : 'Activate'} Customer`"
    >
      <template #prepend>
        <v-icon
          size="18"
          :icon="customer.is_active ? 'mdi-account-off' : 'mdi-account-reactivate'"
          class="me-1"
        />
      </template>
    </v-list-item>

    <template v-if="currentUser.hasPermission('customers.delete_customer')">
      <v-divider class="pb-1" />
      <v-list-item
        class="text-error"
        @click="emit('customer-delete-pressed', customer)"
        title="Delete Customer"
      >
        <template #prepend>
          <v-icon size="18" icon="mdi-delete" class="me-1" />
        </template>
      </v-list-item>
    </template>
  </MoreOptionsMenuButton>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
import { storeToRefs } from 'pinia'

import type { ICustomer } from '@/models/customer'

import { useAuthStore } from '@/stores'

import MoreOptionsMenuButton from '../common/MoreOptionsMenuButton.vue'

interface Props {
  customer: ICustomer
}
defineProps<Props>()

interface Emit {
  (e: 'customer-edit-pressed', customer: ICustomer): void
  (e: 'customer-delete-pressed', customer: ICustomer): void
  (e: 'customer-change-password-pressed', customer: ICustomer): void
  (e: 'customer-change-sites-pressed', customer: ICustomer): void
  (e: 'customer-set-active-pressed', customer: ICustomer): void
}
const emit = defineEmits<Emit>()

const attrs = useAttrs()

const authStore = useAuthStore()
const { getUser: currentUser } = storeToRefs(authStore)
</script>
